import React from 'react';

export default function CartTable({children}){

	return <table className="table table-cart">
		<tbody valign="middle">
			{children}
		</tbody>
	</table>
}